import {
  GET_FOLLOWED_CONTENT_REQUEST,
  GET_FOLLOWED_CONTENT_SUCCESS,
  GET_FOLLOWED_CONTENT_ERROR,
  UNSUBSCRIBE_FOLLOWED_CONTENT_SUCCESS,
  UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR,
  UNSUBSCRIBE_FOLLOWED_CONTENT_REQUEST,
} from "../../constants/action-types";

export const followedContentInitialState = {
  isFetching: false,
  isDeleting: false,
  followedContentViewModel: null,
  unfollowErrorMessage: null,
};

export const reducer = (
  state = followedContentInitialState,
  { type, payload }
) => {
  switch (type) {
    case GET_FOLLOWED_CONTENT_REQUEST:
      return {
        ...state,
        isFetching: true,
        unfollowErrorMessage: null,
        followedContentViewModel: null,
      };
    case GET_FOLLOWED_CONTENT_SUCCESS:
    case GET_FOLLOWED_CONTENT_ERROR:
      return {
        ...state,
        isFetching: false,
        followedContentViewModel: payload,
      };
    case UNSUBSCRIBE_FOLLOWED_CONTENT_REQUEST:
      return {
        ...state,
        isDeleting: true,
        unfollowErrorMessage: null,
      };
    case UNSUBSCRIBE_FOLLOWED_CONTENT_SUCCESS: {
      const updatedFollowedFeeds = state.followedContentViewModel.content.followedFeeds.filter(
        ({ id }) => id !== payload?.id
      );

      return {
        ...state,
        isDeleting: false,
        followedContentViewModel: {
          ...state.followedContentViewModel,
          content: {
            ...state.followedContentViewModel.content,
            followedFeeds: updatedFollowedFeeds,
          },
        },
      };
    }
    case UNSUBSCRIBE_FOLLOWED_CONTENT_ERROR:
      return {
        ...state,
        isDeleting: false,
        unfollowErrorMessage:
          payload ||
          state.followedContentViewModel.content.unfollowError.errorMessage,
      };
    default:
      return state;
  }
};
